import { EventEmitter, Injectable } from '@angular/core';
import { JwtPayload } from 'jwt-decode';
import { Subject, firstValueFrom } from 'rxjs';
import { environment } from '../../environments/environment';
import { EndPoint } from '../config/endpoint';
import { HttpService } from './http.service';

@Injectable({
  providedIn: 'root',
})
export class CalendarService {
  viewDate;
  selectedDate: Date;
  schoolEventDate: Date;
  eventSubject = new Subject<any>();
  event$ = this.eventSubject.asObservable();
  updateCalendarYear = new EventEmitter<boolean>();

  constructor(private httpService: HttpService) {}

  async addEvent(body: object) {
    try {
      return firstValueFrom(
        this.httpService.post<any>(`${environment.XANO_SERVER_URL}${EndPoint.SchoolCalendar}`, body),
      );
    } catch (error) {
      throw error;
    }
  }

  async schoolCalendarBySchoolId(queryParams: object) {
    try {
      const response = await firstValueFrom(
        this.httpService.post<any>(`${environment.XANO_SERVER_URL}${EndPoint.SchoolCalendarBySchoolId}`, queryParams),
      );
      return this.httpService.decodeToken(response);
    } catch (error) {
      throw error;
    }
  }

  async updateSchoolCalendar(id: number, body: object): Promise<JwtPayload> {
    try {
      const response = await firstValueFrom(
        this.httpService.post<any>(`${environment.XANO_SERVER_URL}${EndPoint.SchoolCalendar}/${id}`, body),
      );
      return this.httpService.decryptToken(response);
    } catch (error) {
      throw error;
    }
  }

  async deleteSchoolCalendar(id: number) {
    try {
      const response = await firstValueFrom(
        this.httpService.delete<any>(`${environment.XANO_SERVER_URL}${EndPoint.SchoolCalendar}/${id}`),
      );
      return response;
    } catch (error) {
      throw error;
    }
  }

  async schoolCalendarById(id: number) {
    try {
      const response = await firstValueFrom(
        this.httpService.get<any>(`${environment.XANO_SERVER_URL}${EndPoint.SchoolCalendar}/${id}`),
      );
      return this.httpService.decodeTokenPagination(response);
    } catch (error) {
      throw error;
    }
  }

  async addAdminSchoolEvents(body: object): Promise<JwtPayload> {
    try {
      const schoolEventToken = await firstValueFrom(
        this.httpService.post<any>(`${environment.XANO_SERVER_URL}${EndPoint.AdminSchoolEvents}`, body),
      );
      return schoolEventToken;
    } catch (error) {
      throw error;
    }
  }

  async updateAdminEvent(id: number, body: object) {
    try {
      const response = await firstValueFrom(
        this.httpService.post<any>(`${environment.XANO_SERVER_URL}${EndPoint.AdminSchoolEvents}/${id}`, body),
      );
      return this.httpService.decodeToken(response);
    } catch (error) {
      throw error;
    }
  }

  async deleteAdminEvent(id: number) {
    try {
      const response = await firstValueFrom(
        this.httpService.delete<any>(`${environment.XANO_SERVER_URL}${EndPoint.AdminSchoolEvents}/${id}`),
      );
      return this.httpService.decodeToken(response);
    } catch (error) {
      throw error;
    }
  }

  async getUpcomingUserEvents(queryParams: object) {
    try {
      const response = await firstValueFrom(
        this.httpService.get<any>(`${environment.XANO_SERVER_URL}${EndPoint.upcoming_admin_events}`, {
          params: queryParams,
        }),
      );
      return this.httpService.decodeToken(response);
    } catch (error) {
      throw error;
    }
  }

  async adminEventById(id: number) {
    try {
      return firstValueFrom(
        this.httpService.get<any>(`${environment.XANO_SERVER_URL}${EndPoint.AdminSchoolEvents}/${id}`),
      );
    } catch (error) {
      throw error;
    }
  }

  async allSchoolCalendar() {
    try {
      // const response =
      return firstValueFrom(this.httpService.get<any>(`${environment.XANO_SERVER_URL}${EndPoint.SchoolCalendar}`));
      // return this.httpService.decodeTokenPagination(response);
    } catch (error) {
      throw error;
    }
  }

  async schoolEventBySchoolIdAndClassroomId(queryParams: object) {
    try {
      const response = await firstValueFrom(
        this.httpService.post<any>(`${environment.XANO_SERVER_URL}${EndPoint.users_by_classroom_ids}`, queryParams),
      );
      return response;
    } catch (error) {
      throw error;
    }
  }

  async academicInformationByCalendarId(params: object) {
    try {
      const response = await firstValueFrom(
        this.httpService.get<any>(`${environment.XANO_SERVER_URL}${EndPoint.teacher_academic_information}`, {
          params,
        }),
      );
      return response;

      // return this.httpService.decodeTokenPagination(response);
    } catch (error) {
      throw error;
    }
  }

  async academicInformationById(id: number) {
    try {
      return firstValueFrom(
        this.httpService.get<any>(`${environment.XANO_SERVER_URL}${EndPoint.teacher_academic_information}/${id}`),
      );
    } catch (error) {
      throw error;
    }
  }

  async addTeacherAcademicInformation(body: object) {
    try {
      const response = await firstValueFrom(
        this.httpService.post<any>(`${environment.XANO_SERVER_URL}${EndPoint.teacher_academic_information}`, body),
      );
      return response;
    } catch (error) {
      throw error;
    }
  }

  async updateTeacherAcademicInformation(id: number, body: object) {
    try {
      const response = await firstValueFrom(
        this.httpService.post<any>(
          `${environment.XANO_SERVER_URL}${EndPoint.teacher_academic_information}/${id}`,
          body,
        ),
      );
      return response;
    } catch (error) {
      throw error;
    }
  }
  async updatePreviousYearTeacherAcademicInformation(body: Object) {
    try {
      const response = await firstValueFrom(
        this.httpService.post<any>(
          `${environment.XANO_SERVER_URL}${EndPoint.update_teacher_academic_information}`,
          body,
        ),
      );
      return response;
    } catch (error) {
      throw error;
    }
  }

  async academicInformationByCalendarAndUserId(params: object) {
    try {
      const response = await firstValueFrom(
        this.httpService.get<any>(
          `${environment.XANO_SERVER_URL}${EndPoint.academic_information_by_calendar_and_user_id}`,
          {
            params,
          },
        ),
      );
      return response;

      // return this.httpService.decodeTokenPagination(response);
    } catch (error) {
      throw error;
    }
  }

  async schoolEventBySchoolId(queryParams: object) {
    try {
      const response = await firstValueFrom(
        this.httpService.post<any>(`${environment.XANO_SERVER_URL}${EndPoint.SchoolCalendarBySchoolId}`, queryParams),
      );
      return this.httpService.decodeToken(response);
    } catch (error) {
      throw error;
    }
  }

  async getstudentParentByClassroomCode(queryParams: object) {
    try {
      const response = await firstValueFrom(
        this.httpService.post<any>(
          `${environment.XANO_SERVER_URL}${EndPoint.student_parent_by_classroom_code}`,
          queryParams,
        ),
      );
      return response;
    } catch (error) {
      throw error;
    }
  }

  async updateMultipleAdminSchoolEvent(queryParams: object) {
    try {
      const response = await firstValueFrom(
        this.httpService.post<any>(
          `${environment.XANO_SERVER_URL}${EndPoint.update_multiple_admin_school_events}`,
          queryParams,
        ),
      );
      return response;
    } catch (error) {
      throw error;
    }
  }

  /**
   * @description Fetch upcoming events based on query parameters.
   * @param queryParams - Object containing filters like school_id, user_id, etc.
   * @returns Promise containing decoded upcoming events response
   */
  async getUpcomingEvents(queryParams: object) {
    try {
      const response = await firstValueFrom(
        this.httpService.get<any>(`${environment.XANO_SERVER_URL}${EndPoint.upcoming_events}`, {
          params: queryParams,
        }),
      );
      return this.httpService.decodeToken(response);
    } catch (error) {
      throw error;
    }
  }
}
